import React, { useState, useEffect, useCallback } from "react";
import { Select, Row, Col, Form, Icon, Spin, DatePicker,message, Input, InputNumber, Button, Radio, Switch } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import "./FormRegistro.scss";
var tiempoMensaje = 5;

export default function FormRegistroArticulo(props) {
//console.log("PROPS REGISTRO", props);
    const { getFieldDecorator } = props.form;

    const dateFormat = "DD-MM-YYYY";
    const timeFormat = "HH:mm";

    const [rangeDates, setRangeDates] = useState({
        minInicio: moment().startOf('day'),
        minFin: moment().startOf('day')
    });

    const [enabledRangeDate, setEnabledRangeDate] = useState({
        fechaInicio: false,
        fechaFin: false,
    });

    const [verificacion, setVerificacion] = useState({
        numero:1});

        const [disableSwitch, setDisableSwitch] = useState(false);
        const [obligatorio, setObligatorio] = useState(false);
    
       
        const handleGuardaArticulo = (e) => {
            let reg=0;
            let valida=false;
           
       
            e.preventDefault();
        //console.log('pruebaxxxxx',e)
        let value=[];
        props.form.validateFieldsAndScroll((err, values) => {
            value=values
            if (!err) {

                //console.log('Received values of form artliq: ', values);
                valida=true
               // props.handleSubmit(values);
            }

        /*    if (cuentaObservacionesSinTexto > 0 || cuentaObservacionesSinTextoUnicos > 0) {
                message.error("Los campos de observaciones son obligatorios.", tiempoMensaje);
                return false;
              }*/
        });
       
        //console.log("v1", props.data)
        if (props.opcion ===3){
        props.data.map((val) => {
          //  console.log("v1", val.nombre, "valu1",value.nombre)
         if(val.nombre===value.nombre && val.caracteristica===value.caracteristica)
        {  reg=reg+1
              
            //console.log("v2")
         }
     
        })}
            else {
                reg=0;
            }
   //console.log("v6", reg)
        if( reg >0){
            message.error("Este artículo ya fue registrado. Puedes modificarlo en la tabla de abajo en el aplicador correspondiente", tiempoMensaje);
            return false;} 
                else if ( reg ===0 && valida===true) {
                    //console.log("entro en else")
           return props.handleSubmit(value);
        }
        
   
        
              
    };

    const handleRangeNumber = (rule, value, callback) => {
        if (value && (value > rule.max || value < rule.min)) {
            callback(rule.message)
        }
        callback()
    }

    
    return (
        <div>
          
            <div>
                <Form onSubmit={handleGuardaArticulo} layout="vertical">
                <Row>
                        <Col span={23} >
                        <label className="texto-18-adjudicacion-b"> 
                        {props.opcion ===1 ? "Boletas electorales"
                        :props.opcion ===2 ? "Actas de casillas"
                        :props.opcion ===3 && "Líquido indeleble"
                         }</label>
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col span={11}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">
                                    Tipo de {props.opcion ===1 ? "boletas":props.opcion ===2 ? "actas":props.opcion ===3 && "aplicador"
                                    }</label>
                            </Col> 
                            </Col>
                            </Row>
                            <Row>
                            <Col span={22}>
                            <Col span={22}>
                                <Form.Item name="nombre" hasFeedback>
                                    {getFieldDecorator('nombre', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Seleccione un tipo de artículo.',
                                            }
                                        ],
                                    })(
                                        <Select
                                            placeholder="Seleccione opción"
                                        >
                                            {props.optionsTipoA.map((value, index) => {
                                                 let splited = value.split("-")
                                                 let valor
                                                 
                                                 props.opcion===3 ? valor= splited[2]:valor=splited[1] 

                                                 /*//console.log("val0", splited[0],"val1", splited[1],"val2", splited[2])
                                                 let splited1 = splited[2].split(" ")
                                                 splited1[8]?splited2= splited1[7]  + " " + splited1[8]:splited2=splited1[7]*/
                                                   return  <Select.Option  
                                                    key={value}>{valor}</Select.Option> 
                                                   
                                                      })}
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        </Row>
                        <Row>
                        <Col span={5}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Cantidad de {props.opcion ===1 ? "boletas":props.opcion ===2 ? "actas":props.opcion ===3 && "aplicadores"
                                    }</label>
                            </Col>
                        </Col>
                        {props.opcion ===1 || props.opcion ===2 ? 
                        <Col span={9}>
                        <Col span={23}>
                            <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Medida de seguridad</label>
                        </Col>
                        </Col>
                        :props.opcion ===3 && 
                        <Col span={6}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-adjudicacion">Característica</label>
                            </Col>
                        </Col>}

                        <Col span={10}>
                            <Col span={22}>
            
                                    <label className="rojo-adjudicacion">* </label><label className="texto-16-seguimiento">Descripción de la medida</label>
                                
                                
                            </Col>
                        </Col>
                    </Row>
                    
                    <Row>
                    
                        <Col span={5}>
                            <Col span={20}>
                                
                              
                                    <Form.Item name="cantidad" hasFeedback>
                                        {getFieldDecorator('cantidad', {
                                            rules: [
                                                {
                                                    type: 'integer',
                                                    message: 'Cantidad no válida.',
                                                },
                                                {
                                                    required: true,
                                                    message: 'Ingrese la cantidad de articulos verificados.',
                                                },
                                                {
                                                    validator: handleRangeNumber,
                                                    message: 'Canitdad fuera del rango permitido.',
                                                    min: 1,
                                                    max: 999
                                                }
                                            ], 
                                        })(
                                            <InputNumber
                                            placeholder="Ingrese un número"
                                                style={{ width: '100%' }}
                                                min={1}
                                                max={999}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                
                                            />
                                        )}
                                    </Form.Item>
                                </Col>
                            </Col>
                            {props.opcion ===1 || props.opcion ===2 ? 
                    <Col span={9}>
                            <Col span={23}>
                                <Form.Item name="medidaSeguridad" hasFeedback>
                                    {getFieldDecorator('medidaSeguridad', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese una medida de seguridad.',
                                            }
                                        ],
                                    })(
                                        <Input
                                            placeholder="Ingrese una medida de seguridad."
                                            maxLength={524}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                        :props.opcion ===3 &&
                        <Col span={6}>
                            
                            <Form.Item name="caracteristica" hasFeedback>
                                    {getFieldDecorator('caracteristica', {
                                        initialValue:verificacion.numero,
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Selecciona unacaracterística.',
                                            }
                                        ],
                                    })(
                            <Col span={20}>           
                                        <Radio.Group name="radiogroup"
                            defaultValue={verificacion.numero}
                            >
                            <Radio value={1}>Marca</Radio>
                            <Radio value={2}>Impresión</Radio>
                        </Radio.Group></Col>
                                    )}
                                </Form.Item>

                                
                        </Col>}
                        
                        <Col span={10}>
                            <Col span={22}>
                                <Form.Item name="descripcion">
                                    {getFieldDecorator('descripcion', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese la descripción de la medida de seguridad.',
                                            }
                                        ],
                                    })(
                                        <Input.TextArea
                                            placeholder="Ingrese la descripción de la medida de seguridad"
                                            rows={2}
                                            autoSize={{ minRows: 2, maxRows: 2 }}
                                            allowClear={true}
                                            maxLength={1500}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Col>
                    </Row>
                    <Row>
                 
                       
                        <Col span={5}>
                            <Col span={23}>
                                <label className="rojo-adjudicacion">* </label><label className="texto-16-seguimiento">Resultado (%)</label>
                           </Col>
                        </Col>
                        <Col span={10}>
                            <Col span={22}>
                           {obligatorio? <label className="rojo-adjudicacion">* </label>:""}  <label className="texto-16-seguimiento">Comentario</label>
                           </Col>
                        </Col>
                    </Row>
                    <Row>
                    
                     
                        <Col span={5}>
                            <Col span={16}>                             
                            <Form.Item name="resultado" hasFeedback>
                                        {getFieldDecorator('resultado', {
                                            rules: [
                                                {
                                                    type: 'number',
                                                    message: 'Resultado no válido.',
                                                },
                                                {
                                                    required: true,
                                                    message: 'Ingrese el resultado de la medida de seguridad.',
                                                },
                                                {
                                                    validator: handleRangeNumber,
                                                    message: 'Canitdad fuera del rango permitido.',
                                                    min: 1,
                                                    max: 100
                                                }
                                            ],
                                        })(
                                            <InputNumber
                                                style={{ width: '100%' }}
                                                min={1}
                                                max={100}
                                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                                onChange={value => {
                                                if(value<100)
                                                    setObligatorio(true);
                                                else if(value===100)
                                                setObligatorio(false);
                                                }}
                                                
                                            />
                                        )
                                        }
                                    </Form.Item>
                                </Col>
                                
                            </Col>

                            <Col span={15}>
                            <Col span={14}>
                                        {obligatorio?
                                <Form.Item name="comentarios">
                                    {getFieldDecorator('comentarios', {
                                        rules: [
                                            {
                                                required: true,
                                                message: 'Ingrese los comentarios.',
                                            }
                                        ],
                                    })(
                                        <Input.TextArea
                                            placeholder="Ingrese los comentarios"
                                            rows={2}
                                            autoSize={{ minRows: 2, maxRows: 2 }}
                                            allowClear={true}
                                            maxLength={1500}
                                        />
                                    )}
                                </Form.Item>:

                                <Form.Item name="comentarios">
                                    {getFieldDecorator('comentarios', {})(
                                        <Input.TextArea
                                            placeholder="Ingrese los comentarios"
                                            rows={2}
                                            autoSize={{ minRows: 2, maxRows: 2 }}
                                            allowClear={true}
                                            maxLength={1500}
                                        />
                                    )}
                                </Form.Item>}
                            </Col>
                        </Col>
                        <Col span={3} >
                            <Col>                          
                                <Form.Item >
                                    <Button className="agregar" type="primary" htmlType="submit" disabled={!props.enableCaptura}>
                                        <PlusOutlined />Agregar
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Col>
                       
                    </Row>
                </Form>
            </div>
        </div>
    )
}